function tocMenu() {
    const container = document.querySelector('.single-post__content');

    if (!container) { return }

    const titles = [];

    container.querySelectorAll('h2').forEach((tag) => {
        let str = tag.innerText.replace(/[^\w\s]|_/g, "").replace(/\s+/g, " ");
        let anchorText = str.toLowerCase().split(' ').join('-');
        let anchorTag = document.createElement('a');

        anchorTag.id = anchorText;

        if (anchorText !== '') {
            tag.prepend(anchorTag);
        }

        const anchor = tag.querySelector('a[id]');

        if (anchor) {
            titles.push(tag);
        }
    });

    let html = '<ul class="toc-menu">';
    let open = false;

    for (let i = 0; titles.length > i; i++) {
        const title = titles[i];
        const anchor = title.querySelector('a[id]');

        let item = '';

        if (open && title.tagName === 'H2') {
            item += '</ul></li>';
            open = false;
        }

        item += `
            <li data-tag="${title.tagName}" data-id="${anchor.getAttribute('id')}">
                <a href="#${anchor.getAttribute('id')}">
                    <span>${i+1}.</span>${title.innerText}
                </a>
            `;

        if (typeof titles[i + 1] !== 'undefined') {
            if (title.tagName === 'H2' && titles[i + 1].tagName !== 'H2') {
                item += '<ul>';
                html += item;
                open = true;

                continue;
            }
        }

        item += '</li>';
        html += item;
    }

    if(open) {
        html += '</ul></li>';
        open = false;
    }

    html += '</ul>';

    const contentContainer = document.querySelector('.toc-menu-wrap');

    contentContainer.insertAdjacentHTML('afterbegin', html);

    let links = document.querySelectorAll('.toc-menu li a');

    links.forEach((link) => {
        link.addEventListener('click', function H(e) {
            e.preventDefault();

            let target = this.getAttribute('href');

            $('html, body').animate({ scrollTop: $(target).offset().top - 78 }, 1000);
        })
    })
}
tocMenu();
